import $ from 'jquery';
import EventEmitter from 'events';
export const mathJaxRenderEventHub = new EventEmitter();

// <script type="text/x-mathjax-config">
//   window['M_CB_XXXX] = () => resolve(window.MathJax)
// </script>
// <script src='http://s3.cn-northwest-1.amazonaws.com.cn/qa-static-analytics.cdn.zhihuiya.com-cn-northwest-1/mathjax/MathJax.js?config=MML_HTMLorMML-full' async></script>

let mathLoadPromise = null;
let resolvedMJ = false;

const loadMathJs = () => {
    if (resolvedMJ) {
        return Promise.resolve(resolvedMJ);
    }
    if (mathLoadPromise) {
        return Promise.resolve(mathLoadPromise);
    }

    const head = document.getElementsByTagName('head')[0];
    const mathCallbackScript = document.createElement('script');
    const script = document.createElement('script');

    mathCallbackScript.type = 'text/x-mathjax-config';
    const callbackFnName = `M_CB_${Math.random()}`;

    mathLoadPromise = new Promise((resolve, reject) => {
        window[callbackFnName] = () => {
            resolvedMJ = window.MathJax;
            resolve(resolvedMJ);
        };
        script.onerror = reject;
    });

    mathCallbackScript.innerHTML = `
    MathJax.Hub.Config({
        skipStartupTypeset: true, // No auto render
        tex2jax: {
            inlineMath: [ ['$','$'], ["\\(","\\)"] ],
            displayMath: [ ['$$','$$'], ["\\[","\\]"] ]
        },
    });
    MathJax.Hub.Register.StartupHook("End",function () {
        window['${callbackFnName}']();
    });
    `;

    script.type = 'text/javascript';
    script.src = `${process.env['VUE_APP_STATIC_COMMON_URL']}/mathjax/MathJax.js?config=MML_HTMLorMML-full`;
    [mathCallbackScript, script].forEach(item => {
        item.charset = 'utf-8';
        head.appendChild(item);
    });

    mathLoadPromise.then((MathJaxInstance) => {
        mathLoadPromise = MathJaxInstance;
    });

    return mathLoadPromise;
};

export function callMathRender(el) {
    console.log('callMath');
    setTimeout(function() {
        if (!el.querySelector('math')) return;
        loadMathJs().then(function(MathJax) {
            setTimeout(function() {
                $(el)
                    .find('[data-mathml~=error]')
                    .each(function(idx, ele) {
                        const $ele = $(ele);
                        const id = $ele.attr('id').replace('-Frame', '');
                        const $sourceScript = $(`#${id}`);
                        const oriHTML = $sourceScript.html();
                        $ele.replaceWith(oriHTML);
                    });
                $(el)
                    .find('.MathJax_Error')
                    .each(function(idx, ele) {
                        const rawHTML = $(ele)
                            .siblings('[type^=math]')
                            .html();
                        if (rawHTML) {
                            $(ele).replaceWith(rawHTML);
                        }
                    });
                mathJaxRenderEventHub.emit('done');
            }, 2000);
            MathJax.Hub.Queue(['Typeset', MathJax.Hub, el]);
        });
    }, 200);
}

const hasMutationOb = 'MutationObserver' in window;
export function observe(el, cb) {
    const config = { attributes: false, childList: true };
    if (hasMutationOb && typeof cb === 'function') {
        el._mathMuObserver = new MutationObserver(cb);
        el._mathMuObserver.observe(el, config);
        return true;
    }
    if (el._mathMuObserver) {
        el._mathMuObserver.disconnect();
    }
    return false;
}
